module.exports = __webpack_public_path__ + "img/FCST-ability-03.b2b7e5cb.png";